import React from 'react';
import { VariantModel } from '../../models/VariantModel';
import { formatMoney } from 'accounting';

export const ModelWalkDetailedPricing = (variant: any): any => {
  const affectedModels = [
    'AUEW2DKBV',
    'AUEW2DKCV',
    'AUBU9AK2L',
    'AUBU9AK2L_P',
    'AUBU9AKAL',
    'AUBUAAKL8',
    'AUBUAAKL8_A',
    'AUGU7CKML',
    'AUGU7CKPL',
    'AUGU7CKPL_S',
    'AUGUECKML',
    'AUGUECKPL',
    'AUGU7CKAL',
    'AUGU7CKBL_S',
    'AUZD8EKH8',
    'AUZD8EKH7',
    'AUZD8EKE8',
    'AUZD8EKE7',
    'AUZD8EKS8',
    'AUZD8EKS7',
    'AUZD8EKS8_S',
    'AUZD8EKS7_S',
  ];

  let disclaimer: JSX.Element;
  if (affectedModels.includes(variant.pimIdentifier ?? '')) {
    disclaimer = (
      <p>
        <sup>1</sup> Price is the manufacturer&apos;s recommended retail
        driveaway price (RDP) and includes the vehicle price, 12 months
        registration, stamp duty, luxury car tax (if applicable), CTP insurance
        cost estimate (based on private purchaser with good driving record), a
        recommended charge for dealer delivery and premium paint (if selected).
        The quoted RDP is an estimate based on the postcode selected by you. RDP
        may change based on location. RDP is not applicable to business or
        government buyers. Final on road costs may vary according to individual
        circumstances and actual driveaway price may vary between Retailers. Ask
        your Retailer for confirmation of their driveaway price.
      </p>
    );
  } else {
    disclaimer = (
      <p>
        <sup>1</sup> Price is the manufacturer's recommended retail driveaway
        price (RDP) and includes the vehicle price, 12 months registration,
        stamp duty, luxury car tax (if applicable), CTP insurance cost estimate
        (based on private purchaser with good driving record) and a recommended
        charge for dealer delivery. The quoted RDP is an estimate based on the
        postcode selected by you. RDP may change based on location. RDP is not
        applicable to business or government buyers. Final on road costs may
        vary according to individual circumstances and actual driveaway price
        may vary between Retailers. Ask your Retailer for confirmation of their
        driveaway price.
      </p>
    );
  }

  return (
    <div className="modelWalk__detailedPricing">
      {variant.rdp ? (
        <p className="h2">
          <strong>
            From {formatMoney(variant.rdp, { symbol: '$', precision: 0 })} RDP
            <sup>1</sup>
          </strong>
        </p>
      ) : (
        <p className="h2">
          <strong>
            RDP N/A<sup>1</sup>
          </strong>
        </p>
      )}
      {disclaimer}
      <p>&nbsp;</p>
      <p>
        <strong>
          From {formatMoney(variant.mlp, { symbol: '$', precision: 0 })} MLP
          <sup>2</sup>
        </strong>
      </p>
      <p>
        <sup>2</sup> MLP Prices are Manufacturer's List Price (MLP) only and
        include GST on the list price but exclude dealer delivery charges and
        all other government and statutory charges. MLP's are provided for
        comparative purposes only and may be subject to change. For the drive
        away price of vehicles see the manufacturer's website or contact your
        local authorised retailer.
      </p>
    </div>
  );
};
